import { Subscription } from 'rxjs/Rx';
import { QaService } from '../../../services/qa.service';
import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Color, ColorGroup, VisualizerResponse } from '../../../models/color.model';
import { VisualizerService } from '../../../services/visualizer.service';
import { ScrollingService } from '../../../services/scrolling.service';
import { Modal } from '../../../models/qa.model';
import { AnswerInfoService } from '../../../services/answer-info.service';
import { WoodTypeEnum } from '../../../models/wood-type';
import { ModalComponent } from '../../shared/modal/modal.component';
import { StartupService } from '../../../services/startup.service';
import { HistoryService } from '../../../services/history.service';

@Component({
  selector: 'app-color-groups',
  templateUrl: './color-groups.component.html',
  styleUrls: ['./color-groups.component.scss']
})
export class ColorGroupsComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  private color: Color;
  colorGroups: ColorGroup[];
  sliderWidth: string;
  @ViewChild('slider') slider;
  @ViewChild('eliteToolTip') eliteToolTip: ModalComponent;
  @ViewChild('waterguardToolTip') waterguardToolTip: ModalComponent;
  public message: Number;
  eliteModal: Modal;
  waterguardModal: Modal;
  private pickedCedarOrRedwoodOrComposite: boolean = false;

  constructor(
    public visualizerService: VisualizerService,
    private qaService: QaService,
    private scrollingService: ScrollingService,
    private answerInfoService: AnswerInfoService,
    private startupService: StartupService,
    private historyService: HistoryService) { }

  ngOnInit() {
    this.colorGroups = this.visualizerService.visualizerData.ColorGroups;
    this.sliderWidth = this.calculateSliderSize();
    this.subscription = this.visualizerService.selectedColor.subscribe(c => {
      this.color = c;
    });
// tslint:disable-next-line: max-line-length
  this.pickedCedarOrRedwoodOrComposite = this.answerInfoService.getSelectedWoodType() === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.Cedar) ||
                              this.answerInfoService.getSelectedWoodType() === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.Redwood) ||
                              // tslint:disable-next-line: max-line-length
                              this.answerInfoService.getSelectedWoodType() === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.Composite);

    if (this.color != null) {
      this.visualizerService.visualizerData.ColorGroups.forEach(colorGroup => {
        colorGroup.OpacityColors.forEach(colors => {
          colors.forEach(color => {
            if (color.ItemGUID === this.color.ItemGUID) {
              color.IsSelected = true;
            }
          });
        });
      });
    }

    this.eliteModal = new Modal({
      Image: this.startupService.startupData.BrandInfo.EliteModalImage,
      Title: this.startupService.startupData.BrandInfo.EliteModalTitle,
      Text: this.startupService.startupData.BrandInfo.EliteModalText,
      HideModal: true,
      ButtonText: this.startupService.startupData.BrandInfo.EliteModalButtonText,
    });
    this.waterguardModal = new Modal({
      Image: this.startupService.startupData.BrandInfo.WaterguardModalImage,
      Title: this.startupService.startupData.BrandInfo.WaterguardModalTitle,
      Text: this.startupService.startupData.BrandInfo.WaterguardModalText,
      HideModal: true,
      ButtonText: this.startupService.startupData.BrandInfo.WaterguardModalButtonText,
    });

    let eliteCount = 0;
    let waterguardCount = 0;

    this.historyService.setSelectedWoodType(this.answerInfoService.getSelectedWoodType());

    this.visualizerService.selectedColor.subscribe(x => {
      if (x != null) {
        if (eliteCount === 0 &&
          x.IsElite &&
          // this.answerInfoService.getSelectedWoodType() === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.PressureTreated) &&
          !this.pickedCedarOrRedwoodOrComposite &&
          this.eliteToolTip.modal !== undefined
          ) {
          this.eliteToolTip.modal.HideModal = false;
          this.eliteToolTip.modal.modalStatus(false);
          eliteCount++;
        }
        if (waterguardCount === 0 && x.IsWaterGuard && this.waterguardToolTip && this.waterguardToolTip.modal !== undefined) {
          this.waterguardToolTip.modal.HideModal = false;
          this.waterguardToolTip.modal.modalStatus(false);
          waterguardCount++;
        }
      }
    });
  }

  scrolling(event: Event) {
    this.scrollingService.changeMessage(event.srcElement['getBoundingClientRect']().left);
  }

  calculateSliderSize() {
    const leftRightGroupMargin = 24;
    const swatchWidth = 44;
    const swatchMargin = 4;

    const numberOfGroups = this.colorGroups.length;
    let numberOfColumns = 0;

    const selectedDeck = this.answerInfoService.getSelectedProjectTitle() === 'Deck';
    // tslint:disable-next-line: max-line-length
    const selectedComposite = this.answerInfoService.getSelectedWoodType() === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.Composite);

    if (!selectedDeck || selectedComposite) {
      this.colorGroups = this.colorGroups.filter(group => group.OpacityName !== 'Resurfacer');
    }

    if (
      this.answerInfoService.getSelectedWoodType() === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.Cedar) ||
      this.answerInfoService.getSelectedWoodType() === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.Redwood)
    ) {
      const colorGroups = this.colorGroups;
      let allOpacityColors = [];

      const tempArray = [];
      colorGroups.forEach((x) => {
        allOpacityColors = [];

        x.OpacityColors.forEach((group) => {
          group.forEach((color) => {
            if (color.IsElite) {
              // push elite colors to new array
              tempArray.push(color);
            }
            allOpacityColors.push(color);
          });
        });

        if (allOpacityColors.find(color => color.IsElite === true)) {
          let count = 0;
          let colorGroup = [];
          const eliteColorGroups = [];

          tempArray.forEach((color) => {
            if (count === 4) {
              eliteColorGroups.push(colorGroup);
              colorGroup = [];
              count = 0;
            }
            colorGroup.push(color);
            count++;
          });

          numberOfColumns += eliteColorGroups.length;
        } else {
          numberOfColumns += x.OpacityColors.length;
        }
      });
    } else {
      this.colorGroups.forEach(c => numberOfColumns +=  c.OpacityColors.length);
    }

    const sliderWidth = (numberOfColumns * swatchWidth) + (numberOfColumns * swatchMargin) + (numberOfGroups * leftRightGroupMargin) + 140;

    return `${sliderWidth}px`;
  }
  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizer/color-groups/color-groups.component.ts